module.exports = __webpack_public_path__ + "img/banner_3.6a7478ed.png";